/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.createSession'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  password: /*#__PURE__*/ l.string(),
  identifier: /*#__PURE__*/ l.string(),
  allowTakendown: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  authFactorToken: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  active: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  didDoc: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
  handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  status: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: ['takendown', 'suspended', 'deactivated']
    }>(),
  ),
  accessJwt: /*#__PURE__*/ l.string(),
  refreshJwt: /*#__PURE__*/ l.string(),
  emailConfirmed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  emailAuthFactor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Create an authentication session. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'AccountTakedown',
  'AuthFactorTokenRequired',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
